
import { ModuleFilterActions, ModuleFilterActionTypes } from '../actions/module-filter.actions';

export interface State {
  RegionId: number;
  Package: string;
}

export const initialState: State = {
  RegionId: 1,
  Package: 'Standard'
};

export function reducer(state = initialState, action: ModuleFilterActions): State {
  switch (action.type) {

    case ModuleFilterActionTypes.LoadModuleFilters:
      return {...state, Package: action.payload.Package , RegionId: action.payload.RegionId};

    default:
      return state;
  }
}
